import { Tooltip } from 'antd';
import { HighlightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

function plural(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

interface WhiteboardBadgeProps {
  board: { elementCount: number; updatedAt: string } | undefined;
}

/** Значок «у записи есть доска» рядом с названием в таблице и на канбане. */
export function WhiteboardBadge({ board }: WhiteboardBadgeProps): JSX.Element | null {
  if (!board) return null;
  const n = board.elementCount;
  return (
    <Tooltip
      title={`Доска: ${n} ${plural(n, 'элемент', 'элемента', 'элементов')}, правили ${dayjs(board.updatedAt).format('DD.MM.YYYY')}`}
    >
      <HighlightOutlined
        aria-label="Есть доска"
        data-testid="whiteboard-badge"
        style={{ color: 'var(--color-text-secondary)', fontSize: 12, marginInlineStart: 6, flex: 'none' }}
      />
    </Tooltip>
  );
}
